export default "__VITE_ASSET__96d5b0cd__"